import {Injectable} from '@angular/core';
import {DataCoreService} from '@dabnet-kamu/libs/ui';
import {TemHesapService} from '../ctl-tem-hesap.service';

@Injectable()
export class Service {

  constructor(private dataCoreService: DataCoreService, private service: TemHesapService) {
  }

  getData(control: any) {
    const baseEntity = this.service.baseEntity?this.service.baseEntity:control.dlistMetadata.baseEntity
    const dataSource = this.dataCoreService.getOData(baseEntity);
    dataSource.select([]);
    const filterArr = [];
    if (this.service.period) filterArr.push(['Donem', '=', this.service.period]);
    if (!this.service.isMain) filterArr.push(['DetaySayisi', '=', 0]);
    if(this.service.onlyMainAccount) filterArr.push(['DetaySayisi', '>', 0]);
    // if (this.service.codeStart) filterArr.push(['HesapKod', 'startswith', this.service.codeStart]);
    if (this.service.codeStart) {
      if (Array.isArray(this.service.codeStart)) {
        // Birden fazla startswith koşulunu or ile gruplandır
        const elements = this.service.codeStart.map((start) => ['HesapKod', 'startswith', start]);
        // İlk elemandan sonra 'or' ekleyerek hepsini tek bir array olarak ekle
        const withOr = elements.flatMap((element, index) => index < elements.length - 1 ? [element, 'or'] : [element]);
        filterArr.push(withOr)
      } else {
        // Tek bir this.service.codeStart değeri varsa
        filterArr.push(['HesapKod', 'startswith', this.service.codeStart]);
      }
    }
    if(this.service.controlCondition){
      this.service.controlCondition.forEach((item:any) => {
        if(this.service.notContain){
          filterArr.push(['!',[item.conditionColName, item.conditionColSymbol, item.conditionColText]]);
        } else {
          filterArr.push([item.conditionColName, item.conditionColSymbol, item.conditionColText]);
        }
      });
    }

    if(this.service.accountCodeLength) filterArr.push(['HesapKod.Length', '=', this.service.accountCodeLength]);
    if (filterArr.length > 0) dataSource.filter(filterArr)
    return dataSource;
  }

}
